<script setup>
import router from '@/router/index.js';
import { url } from '@/config/urls';
import { modalUtil } from '@functions/modalUtil';

const emit = defineEmits(['addToCart', 'backPrev']);

const props = defineProps({
  settingPageUrl: {type: String, default: url.page.setting.index},
});

const { hideModal } = modalUtil();

const toUserSettingPage = () => {
  hideModal('toUserSettingConfirmModal');
  router.push(props.settingPageUrl + '#service-apply');
}
</script>

<template>
  <div class="modal com_modal2 fade" id="toUserSettingConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb5 com_lh1">ユーザー管理画面でバーコードスキャンの利用申し込みをしてください
          </h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_app_btn1" data-bs-dismiss="modal" @click="toUserSettingPage">ユーザー管理画面へ</button>
          <button type="button" class="btn com_app_btn2" data-bs-dismiss="modal" @click="hideModal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>